import { createContext, useContext } from "react";

export type FeedbackThreshold = {
  value: number;
  crossed: boolean;
};

export type FeedbackState = "toast" | "pip" | null;

export type FeedbackContextValues = {
  feedbackState: FeedbackState;
  incrementEngagementCount: () => void;
  onFeedbackToastDismissed: () => void;
  onFeedbackEngaged: () => void;
};

export const FeedbackContext = createContext<FeedbackContextValues | undefined>(
  undefined
);

export const useFeedback = () => {
  const context = useContext(FeedbackContext);

  if (context === undefined) {
    throw new Error("useFeedback must be inside a FeedbackProvider");
  }

  return context;
};
